module.exports = __webpack_public_path__ + "static/img/6.278b3a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/zh/6.png
// module id = 30Ii
// module chunks = 0